var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmartlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464646",
  d: "M20.622 15.752c1.859 0 3.622.053 4.96.148-.476-2.534-2.591-4.507-4.95-4.507s-4.475 1.973-4.951 4.506c1.336-.094 3.092-.147 4.94-.147M26.708 17l-.594-.053c-1.354-.124-3.356-.195-5.492-.195-2.124 0-4.12.07-5.475.193l-.592.053.049-.594c.278-3.315 2.98-6.011 6.028-6.011s5.75 2.698 6.026 6.014zm-13.082.044v9.289c0 .603.51 1.093 1.137 1.093h11.725c.627 0 1.138-.49 1.138-1.093l-.001-9.37c-.03-4.118-3.23-7.538-6.993-7.538-3.748 0-6.947 3.409-6.988 7.441zm12.862 11.381H14.763c-1.178 0-2.137-.939-2.137-2.093l.02-9.611c.117-4.511 3.744-8.295 7.986-8.295 4.27 0 7.907 3.819 7.987 8.362l.007.122v9.423c0 1.154-.96 2.093-2.138 2.093"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#464646",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 8,
  fontWeight: 400
}, /*#__PURE__*/React.createElement("tspan", {
  x: 16.078,
  y: 24.512
}, "00")))));
export default SvgSmartlock;